import { isNullOrEmpty } from "../lib/helper";

const DE = require('../localization/de.json');
const EN = require('../localization/en.json');
const PL = require('../localization/pl.json');

const languages: any = { de: DE, en: EN, pl: PL }

export class LocalizationService {
    private language: string = "en";

    constructor(language: string) {
        if (language === "de" || language === "pl") {
            this.language = language;
        }
    }

    public supportedCultures: { translationKey: string, key: string }[] = [
        { translationKey: "English", key: "en" },
        { translationKey: "German", key: "de" },
        { translationKey: "Polish", key: "pl" }
    ];

    public supportedCountries: { translationKey: string, key: string, defaultLanguageKey: string }[] = [
        { translationKey: "Switzerland", key: "ch", defaultLanguageKey: "de" }
    ];

    public isValidCulture(lang: string): boolean {
        return this.supportedCultures.filter((l) => l.key === lang).length > 0;
    }

    public isValidCountry(lang: string): boolean {
        return this.supportedCountries.filter((l) => l.key === lang).length > 0;
    }

    public setLanguage(lang: string) {
        if (this.isValidCulture(lang)) {
            this.language = lang;
        }
    }

    public getLocalizedText(key: string): string {
        if (
            !isNullOrEmpty(languages[this.language]) &&
            !isNullOrEmpty(languages[this.language][key])
        ) {
            return languages[this.language][key];
        }
        return key;
    }
}